import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../assets/icons/dots-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-748918ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "blocks-wrapper" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ps-3 ms-1 inline-block" }, "New", -1))
const _hoisted_6 = ["onMouseenter", "onMouseleave"]
const _hoisted_7 = {
  key: 0,
  class: "actions-wrapper d-flex align-items-center"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "actions d-flex" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "dots",
    width: "20",
    class: "drag-icon cursor-pointer"
  })
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  "data-bs-toggle": "modal",
  "data-bs-target": "#deleteTaskModal"
}
const _hoisted_12 = { key: 2 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-state" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "No tasks yet")
], -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  type: "button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#selectTaskType",
  ref: "openSelectTaskTypeModal"
}
const _hoisted_16 = {
  type: "button",
  "data-bs-toggle": "offcanvas",
  "data-bs-target": "#taskSidebar",
  ref: "openModal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_spinner = _resolveComponent("loading-spinner")!
  const _component_feather_icon = _resolveComponent("feather-icon")!
  const _component_task_card = _resolveComponent("task-card")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_add_form_modal = _resolveComponent("add-form-modal")!
  const _component_delete_task_modal = _resolveComponent("delete-task-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.loaded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_loading_spinner)
          ]))
        : _createCommentVNode("", true),
      (_ctx.loaded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: "btn btn-outline-primary position-relative add-button mb-3 ms-auto",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args)))
              }, [
                _createVNode(_component_feather_icon, {
                  type: "plus",
                  class: "cursor-pointer add-icon",
                  size: "20"
                }),
                _hoisted_5
              ])
            ]),
            _createVNode(_component_draggable, {
              modelValue: _ctx.computedTasks,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedTasks) = $event)),
              group: "tasks",
              "item-key": "taskId",
              handle: ".drag-icon",
              onStart: _cache[2] || (_cache[2] = ($event: any) => (_ctx.drag = true)),
              onEnd: _cache[3] || (_cache[3] = ($event: any) => (_ctx.drag = false)),
              class: "mt-2 mb-2"
            }, {
              item: _withCtx(({ element }) => [
                _createElementVNode("div", null, [
                  _createElementVNode("div", {
                    class: "card-wrapper d-flex savespace align-items-stretch",
                    onMouseenter: ($event: any) => (_ctx.showAction(element.taskId)),
                    onMouseleave: ($event: any) => (_ctx.closeAction(element.taskId))
                  }, [
                    (_ctx.showActions[element.taskId])
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
                      : _createCommentVNode("", true),
                    _createVNode(_component_task_card, {
                      class: "task",
                      task: element
                    }, null, 8, ["task"]),
                    _withDirectives(_createElementVNode("div", {
                      class: "position-relative",
                      onClick: ($event: any) => (_ctx.selectedTask = element)
                    }, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_feather_icon, {
                          type: "trash",
                          class: "cursor-pointer position-absolute mt-3 delete-icon",
                          size: "15",
                          stroke: "#1F3245"
                        })
                      ])
                    ], 8, _hoisted_10), [
                      [_vShow, _ctx.showActions[element.taskId as any]]
                    ])
                  ], 40, _hoisted_6)
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.tasks.length && _ctx.loaded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_add_form_modal),
    _createVNode(_component_delete_task_modal, { task: _ctx.selectedTask }, null, 8, ["task"]),
    _withDirectives(_createElementVNode("button", _hoisted_15, "Open", 512), [
      [_vShow, false]
    ]),
    _withDirectives(_createElementVNode("button", _hoisted_16, "Open", 512), [
      [_vShow, false]
    ])
  ], 64))
}